import { Routes } from '@angular/router';
import { TrialGuard } from '@app/Tenant/guards/free-trial.guard';
import { FreeTrialAdministrationComponent } from './free-trial-administration.component';
import { TrialConfigPageComponent } from './components/trial-config-page/trial-config-page.component';
import { TrialLogPageComponent } from './components/trial-logs-page';

export const TRIAL_ADMINISTRATION_ROUTES: Routes = [
    {
        path: 'trial-administration',
        canActivate: [TrialGuard],
        component: FreeTrialAdministrationComponent,
        children: [
            { path: '', redirectTo: 'config', pathMatch: 'full' },
            { path: 'config', component: TrialConfigPageComponent },
            { path: 'logs', component: TrialLogPageComponent },
        ]
    }
];